const LOGO_URL = "https://customer-assets.emergentagent.com/job_call-capture-ai-1/artifacts/4yf2lu9l_Black%20%26%20Beige%20Modern%20Typography%20Monogram%20Logo%20%283%29.png";

const footerLinks = [
  { label: "How It Works", href: "#how-it-works" },
  { label: "Results", href: "#results" },
  { label: "Pricing", href: "#pricing" },
  { label: "Team", href: "#team" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/[0.06] py-12 px-6 md:px-12"
      style={{ backgroundColor: "#0A0A0A" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-6">
            <a href="#hero" data-testid="footer-logo">
              <img
                src={LOGO_URL}
                alt="Velocity Labs"
                className="h-7 w-auto invert brightness-200"
              />
            </a>
          </div>

          <div className="flex items-center gap-6">
            {footerLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm text-[#A3A3A3] hover:text-white transition-colors duration-200"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                {link.label}
              </a>
            ))}
          </div>

          <p
            className="text-xs text-[#A3A3A3]/60"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            &copy; {new Date().getFullYear()} Velocity Labs. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
